var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSelect',_vm._b({attrs:{"label":_vm.label},on:{"input":function($event){return _vm.$emit('input', $event)}}},'FormSelect',_vm.$attrs,false),_vm._l((_vm.timeZones),function(timeZone){return _c('option',{key:timeZone.value,domProps:{"value":timeZone.value}},[_vm._v(_vm._s(timeZone.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }